<template>
  <div class="bds-page">

    <h2 class="bds-title">Bookings</h2>

    <div class="bds-section">
      <p class="bds-section-sub">
        Review booking actuals matched against telematics, by booking, driver, or vehicle.
      </p>

      <div v-if="cards.length" class="bds-card-grid">
        <router-link
          v-for="card in cards"
          :key="card.route"
          :to="{ name: card.route, query: card.query }"
          class="bds-card"
        >
          <div class="bds-card-title">{{ card.name }}</div>
          <div class="bds-card-desc">{{ card.description }}</div>
        </router-link>
      </div>

      <div v-else class="bds-empty">
        <p>No booking views are available for this account.</p>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getBookingPages } from '@/utils/booking_pages'

export default {
  name: 'booking_dashboard_shell',
  computed: {
    ...mapState({
      user: state => state.profile.user,
    }),
    tenant_type() {
      return this.user.types[this.user.tenant]
    },
    cards() {
      return getBookingPages(this.tenant_type)
    },
  },
}
</script>

<style scoped>
.bds-page {
  padding-bottom: 40px;
}

.bds-title {
  font-size: 26px;
  font-weight: bold;
  color: #222;
  margin-bottom: 16px;
}

.bds-section {
  margin-bottom: 8px;
}

.bds-section-sub {
  color: #555;
  font-size: 14px;
  margin-bottom: 20px;
}

.bds-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  padding-right: 16px;
}

.bds-card {
  border: 1px solid #d0d8e4;
  border-radius: 6px;
  padding: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(70, 130, 180, 0.08);
  transition: box-shadow 0.15s, border-color 0.15s;
  cursor: pointer;
  text-decoration: none !important;
}

.bds-card:hover {
  border-color: steelblue;
  box-shadow: 0 2px 8px rgba(70, 130, 180, 0.18);
  text-decoration: none !important;
}

.bds-card-title {
  font-size: 15px;
  font-weight: bold;
  color: #222;
  margin-bottom: 6px;
}

.bds-card-desc {
  font-size: 13px;
  color: #666;
  flex: 1;
  line-height: 1.4;
}

.bds-empty {
  color: #888;
  font-size: 14px;
  padding: 40px 0;
}
</style>
